import type { FaireProductEntity } from "../../entity_types/product";

export const p_293hb7qjnt: FaireProductEntity = {
  token: "p_293hb7qjnt",
  type: "product",
  name: "Poop Bingo",
  brandName: "Chronicle Books",
  imageUrl:
    "https://cdn.faire.com/fastly/7fcd63b8a060e5a38571e843781b85e951108d5cc51daeee3739fe2faf023156.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b09aee95d1aa7a3cd5ce25862d78b3f15a16aca80df23c7de572680412c94ece.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
